module.exports = __webpack_public_path__ + "static/media/kishoriMv2.a0f35032.png";